"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pointer = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _useResizeObserver = require("../../utils/useResizeObserver");
var _Box = require("../Box");
var _themeGet = require("@styled-system/theme-get");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var POINTER_VARIANTS = {
  defaultLight: {
    backgroundColor: "white100"
  },
  defaultDark: {
    backgroundColor: "black100"
  }
};
/**
 * Internal-use component for displaying a triangular pointer to an anchor node
 */
var Pointer = function Pointer(_ref) {
  var anchorRef = _ref.anchorRef,
    tooltipRef = _ref.tooltipRef,
    isFlipped = _ref.isFlipped,
    placement = _ref.placement,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "defaultLight" : _ref$variant;
  var _useState = (0, _react.useState)([0, 0]),
    _useState2 = _slicedToArray(_useState, 2),
    _useState2$ = _slicedToArray(_useState2[0], 2),
    anchorWidth = _useState2$[0],
    anchorHeight = _useState2$[1],
    setAnchorDimensions = _useState2[1];
  var _useState3 = (0, _react.useState)([0, 0]),
    _useState4 = _slicedToArray(_useState3, 2),
    _useState4$ = _slicedToArray(_useState4[0], 2),
    tooltipWidth = _useState4$[0],
    tooltipHeight = _useState4$[1],
    setTooltipDimensions = _useState4[1];
  var position = (0, _react.useMemo)(function () {
    var horizontalCenter = anchorWidth / 2;
    var verticalCenter = anchorHeight / 2;
    switch (placement) {
      case "top-start":
        return {
          bottom: isFlipped ? "100%" : 0,
          left: "".concat(horizontalCenter > tooltipWidth ? POINTER_WIDTH : horizontalCenter - POINTER_WIDTH / 2, "px")
        };
      case "top":
        return {
          bottom: isFlipped ? "100%" : 0,
          left: "calc(50% - ".concat(POINTER_WIDTH / 2, "px)")
        };
      case "top-end":
        return {
          bottom: isFlipped ? "100%" : 0,
          right: "".concat(horizontalCenter > tooltipWidth ? POINTER_WIDTH * 2 : horizontalCenter + POINTER_WIDTH / 2, "px")
        };
      case "bottom-start":
        return {
          top: isFlipped ? "100%" : 0,
          left: "".concat(horizontalCenter > tooltipWidth ? POINTER_WIDTH : horizontalCenter - POINTER_WIDTH / 2, "px")
        };
      case "bottom":
        return {
          top: isFlipped ? "100%" : 0,
          left: "calc(50% - ".concat(POINTER_WIDTH / 2, "px)")
        };
      case "bottom-end":
        return {
          top: isFlipped ? "100%" : 0,
          right: "".concat(horizontalCenter > tooltipWidth ? POINTER_WIDTH * 2 : horizontalCenter + POINTER_WIDTH / 2, "px")
        };
      case "left-start":
        return _objectSpread({
          top: "".concat(verticalCenter > tooltipHeight - POINTER_WIDTH / 2 ? POINTER_WIDTH : verticalCenter, "px")
        }, isFlipped ? {
          left: "-".concat(POINTER_WIDTH / 2, "px")
        } : {
          right: "".concat(POINTER_WIDTH / 2, "px")
        });
      case "left":
        return _objectSpread({
          top: "50%"
        }, isFlipped ? {
          left: "-".concat(POINTER_WIDTH / 2, "px")
        } : {
          right: "".concat(POINTER_WIDTH / 2, "px")
        });
      case "left-end":
        return _objectSpread({
          bottom: "".concat(verticalCenter > tooltipHeight - POINTER_WIDTH / 2 ? POINTER_WIDTH : verticalCenter, "px")
        }, isFlipped ? {
          left: "-".concat(POINTER_WIDTH / 2, "px")
        } : {
          right: "".concat(POINTER_WIDTH / 2, "px")
        });
      case "right-start":
        return _objectSpread({
          top: "".concat(verticalCenter > tooltipHeight - POINTER_WIDTH / 2 ? POINTER_WIDTH : verticalCenter, "px")
        }, isFlipped ? {
          right: "".concat(POINTER_WIDTH / 2, "px")
        } : {
          left: "-".concat(POINTER_WIDTH / 2, "px")
        });
      case "right":
        return _objectSpread({
          top: "50%"
        }, isFlipped ? {
          right: "".concat(POINTER_WIDTH / 2, "px")
        } : {
          left: "-".concat(POINTER_WIDTH / 2, "px")
        });
      case "right-end":
        return _objectSpread({
          bottom: "".concat(verticalCenter > tooltipHeight - POINTER_WIDTH / 2 ? POINTER_WIDTH : verticalCenter, "px")
        }, isFlipped ? {
          right: "".concat(POINTER_WIDTH / 2, "px")
        } : {
          left: "-".concat(POINTER_WIDTH / 2, "px")
        });
    }
  }, [anchorHeight, anchorWidth, isFlipped, placement, tooltipHeight, tooltipWidth]);
  var handleResize = (0, _react.useCallback)(function () {
    if (!anchorRef.current || !tooltipRef.current) return;
    var anchorRect = anchorRef.current.getBoundingClientRect();
    var tooltipRect = tooltipRef.current.getBoundingClientRect();
    setAnchorDimensions([anchorRect.width, anchorRect.height]);
    setTooltipDimensions([tooltipRect.width, tooltipRect.height]);
  }, [anchorRef, tooltipRef]);
  (0, _react.useEffect)(handleResize, [handleResize]);
  (0, _useResizeObserver.useResizeObserver)({
    target: anchorRef,
    onResize: handleResize
  });
  return /*#__PURE__*/_react.default.createElement(Container, _extends({
    variant: variant
  }, position));
};
exports.Pointer = Pointer;
Pointer.displayName = "Pointer";
var POINTER_SIZE = 10; // px
var POINTER_WIDTH = Math.sqrt(2 * Math.pow(10, 2)); // px

var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Pointer__Container",
  componentId: "sc-sj9j6h-0"
})(["z-index:-1;position:absolute;&::after{content:\"\";position:absolute;width:", "px;height:", "px;transform-origin:0 0;transform:rotate(-45deg);box-shadow:", ";", "}"], POINTER_SIZE, POINTER_SIZE, (0, _themeGet.themeGet)("effects.dropShadow"), (0, _styledSystem.variant)({
  variants: POINTER_VARIANTS
}));
//# sourceMappingURL=Pointer.js.map